import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { CircularProgress } from '@pets-ui/CircularProgress/CircularProgress'
import { Input } from '@pets-ui/Input/Input'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRequestDeleteWordPressUser } from '../../../hooks/apis/wp/useRequestDeleteWordPressUser'
import { wordPressHost } from '../../../utils/location'
import { useContextMyAccountDialog } from './Provider/useContextMyAccountDialog'

const styles = stylex.create({
  successDeleteUser: {
    overflow: 'hidden',
  },
})
interface DialogRepeatBindAccountProps {
  open: boolean
  onClose: () => void
}

export function DialogDeleteAccount(props: DialogRepeatBindAccountProps) {
  const { t } = useTranslation()
  const { open, onClose } = props
  const [conformValue, setConformValue] = useState('')
  const { showDialogServerError } = useContextMyAccountDialog()
  const { trigger: deleteWordPressUser, isMutating: isDeletingWordPressUser } = useRequestDeleteWordPressUser()
  const [successDeleteUser, setSuccessDeleteUser] = useState(false)
  const handleClickDelete = async () => {
    try {
      const { data } = await deleteWordPressUser({
        redirectUrl: `${wordPressHost}/my-account/?deleteAccount=true`,
        fallbackUrl: `${wordPressHost}/my-account/edit-account/?deleteAccount=false`,
      })
      window.location.href = data.data.url
      setSuccessDeleteUser(true)
    }
    catch (e) {
      onClose()
      showDialogServerError()
      setSuccessDeleteUser(false)
      console.error(e)
    }
  }

  return (
    <Dialog
      disablePortal
      onClose={onClose}
      open={open}
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '320px',
            padding: '16px',
          },
        },
      }}
    >
      <DialogTitle sx={{ p: 0, pb: 1 }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Text color={colors.grey900} align="center" variant="h4">{successDeleteUser ? t('login.deleteAccountSuccess') : t('login.deleteAccount')}</Text>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 0, gap: 1, display: 'flex', flexDirection: 'column' }}>
        {successDeleteUser
          ? (
            <VStack rootStyle={styles.successDeleteUser} alignItems="center" gap={2}>
              <Text>{t('login.redirectingDialogContent')}</Text>
              <CircularProgress color={colors.grey300} fontSize={16} />
            </VStack>
          )
          : (
            <>
              <Text align="center" variant="body">{t('login.deleteAccountRemind')}</Text>
              <Input
                placeholder={String(t('login.pleaseEnter'))}
                fullWidth
                value={conformValue}
                error={conformValue !== t('login.deleteMyAccount') && conformValue !== ''}
                onChange={e => setConformValue(e.target.value)}
                onPaste={e => e.preventDefault()}
                disabled={isDeletingWordPressUser || successDeleteUser}
              />
              <DialogActions sx={{ gap: 1, px: 0 }}>
                <Button disabled={isDeletingWordPressUser} variant="outlined" fullWidth onClick={onClose}>
                  {t('button.cancel')}
                </Button>
                <Button loading={isDeletingWordPressUser} fullWidth onClick={handleClickDelete} disabled={conformValue !== String(t('login.deleteMyAccount'))}>
                  {t('login.deleteAccount')}
                </Button>
              </DialogActions>
            </>
          )}
      </DialogContent>
    </Dialog>
  )
}
